import { Component, inject } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { currencies } from "@bitwarden/web-vault/app/gloss/manage/manage-preferences/currencies";
import { DecimalPipe } from "@angular/common";
import { RoleAccessService } from "@bitwarden/web-vault/app/services/permission/role-access.service";

interface AmountRendererParams extends ICellRendererParams {
  triggerByEye?: boolean;
}
@Component({
  selector: "app-amount-renderer",
  templateUrl: "./amount-renderer.component.html",
  providers: [DecimalPipe],
})
export class AmountRendererComponent implements ICellRendererAngularComp {
  private roleAccessService = inject(RoleAccessService);

  balance!: number;
  symbol!: string;
  // A balance-alignment row is identified by transactionView.bankImportedBalance, not by
  // description text - a user-noted alignment row keeps the note as its description, so
  // matching on description would miss it (see #4104).
  isBalanceAlignment: boolean = false;
  triggerByEye: boolean = true;
  // Paired transfer/conversion amounts aren't real gains/losses, so beta users
  // see them de-emphasised (tertiary) rather than in the money in/out colours.
  isLinked: boolean = false;

  agInit(params: AmountRendererParams): void {
    this.setData(params);
  }

  setData(params: AmountRendererParams) {
    this.triggerByEye = params.triggerByEye ?? true;
    this.balance = params.data.balance || 0;
    this.symbol = params.data.symbol || "";
    this.isBalanceAlignment = params.data.transactionView?.bankImportedBalance != null;
    this.isLinked = this.roleAccessService.isBetaUser()
      ? params.data.transactionView?.c_linkType != null
      : false;
  }

  refresh(params: AmountRendererParams): boolean {
    this.setData(params);
    return true;
  }

  protected readonly currencies = currencies;
}
